/**
 * Calculates how many people are in a guest list
 *
 * @param place The place it should look in
 */
export const getTotalUsedPlaces = (place: server.dto.LegacyGuestlistPlace): number => {
  let usedPlaces = 0;

  // Remember:
  // total guests = all the separate guest guests + the sum of all the guests they bring along
  usedPlaces += place.guests.length;
  usedPlaces += place.guests
    .map((entry) => entry.bringsGuests)
    .reduce((total, curr) => total + curr, 0);

  return usedPlaces;
};

export const guestlistIsEmpty = (guestlist: server.dto.LegacyGuestlist): boolean => {
  const places = guestlist.availablePlaces;
  for (const place of places) {
    if (place.guests.length > 0) {
      return false;
    }
  }

  return true;
};
